/*
 * Why not RadioSelect?
 *
 * That's a higher level component that assumes multiple choices. This tries to
 * just wrap a single input. At some point, we probably should use this Radio
 * component inside RadioSelect...
 *
 */

import React from 'react';

import { mergeClassNames } from 'utils/functions';

export const Radio = ({
    inline = true,
    className = '',
    label = '',
    style = {},
    ...inputProps
}) => {
    let classes = mergeClassNames(
        'form-check',
        inline ? 'form-check-inline' : '',
        className
    );

    return (
        <div className={classes} style={style}>
            <label className='form-check-label' htmlFor={inputProps.id}>
                <input className='form-check-input' type='radio' {...inputProps} />
                {label || inputProps.value}
            </label>
        </div>
    );
};
